import React, { useState } from 'react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { MailX, Send, Loader2 } from 'lucide-react';

/**
 * Bannière d'alerte pour les invitations rejetées (bounce Brevo).
 * Chaque destinataire rejeté peut être corrigé + ré-invité en un clic.
 */
export default function BounceAlertBanner({ bounced, onCorrigerRenvoyer }) {
  const [drafts, setDrafts] = useState({});
  const [sending, setSending] = useState(null);

  if (!bounced || bounced.length === 0) return null;

  const submit = async (inv) => {
    setSending(inv.id);
    const ok = await onCorrigerRenvoyer(inv.id, drafts[inv.id] ?? inv.email ?? '');
    setSending(null);
    if (ok) setDrafts((d) => ({ ...d, [inv.id]: undefined }));
  };

  return (
    <div
      className="p-4 rounded-lg border border-rose-300 bg-rose-50 space-y-3"
      data-testid="invitation-bounce-alert"
    >
      <div className="flex items-start gap-3">
        <MailX className="h-5 w-5 text-rose-600 flex-shrink-0 mt-0.5" />
        <div className="text-sm">
          <p className="font-semibold text-rose-800">
            {bounced.length} invitation{bounced.length > 1 ? 's' : ''} rejetée{bounced.length > 1 ? 's' : ''} (adresse invalide)
          </p>
          <p className="text-rose-700 mt-0.5">
            Corrigez l&apos;adresse puis renvoyez l&apos;invitation en un clic.
          </p>
        </div>
      </div>

      <div className="space-y-2">
        {bounced.map((inv) => (
          <div key={inv.id} className="flex items-center gap-2 bg-white rounded-lg border border-rose-200 p-2">
            <div className="flex-1 min-w-0">
              <p className="text-xs text-gray-500">{inv.prenom} {inv.nom}</p>
              <Input
                type="email"
                value={drafts[inv.id] ?? inv.email ?? ''}
                onChange={(e) => setDrafts((d) => ({ ...d, [inv.id]: e.target.value }))}
                placeholder="nouvelle.adresse@email.fr"
                className="h-8 text-sm mt-0.5"
                data-testid={`bounce-correct-email-${inv.id}`}
              />
            </div>
            <Button
              size="sm"
              onClick={() => submit(inv)}
              disabled={sending === inv.id}
              className="bg-rose-600 hover:bg-rose-700 text-white flex-shrink-0"
              data-testid={`bounce-corriger-renvoyer-${inv.id}`}
            >
              {sending === inv.id ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <><Send className="h-4 w-4 mr-1" /> Corriger et renvoyer</>
              )}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
